import { theme } from '../theme';

export const LANGUAGES = [
  { code: 'es', label: 'Español' },
  { code: 'es_MX', label: 'Español (México)' },
  { code: 'es_AR', label: 'Español (Argentina)' },
  { code: 'en_US', label: 'Inglés (EE.UU.)' },
  { code: 'en_GB', label: 'Inglés (Reino Unido)' },
  { code: 'pt_BR', label: 'Portugués (Brasil)' },
  { code: 'pt_PT', label: 'Portugués (Portugal)' },
  { code: 'fr', label: 'Francés' },
  { code: 'de', label: 'Alemán' },
  { code: 'it', label: 'Italiano' },
  { code: 'zh_CN', label: 'Chino (simplificado)' },
  { code: 'ja', label: 'Japonés' },
  { code: 'ko', label: 'Coreano' },
  { code: 'ar', label: 'Árabe' },
];

export const inputStyle = {
  width: '100%', padding: '9px 12px', backgroundColor: theme.colors.background,
  border: `1px solid ${theme.colors.border}`, borderRadius: '7px', color: theme.colors.text,
  fontSize: '0.9rem', boxSizing: 'border-box', outline: 'none',
};

export const labelStyle = {
  display: 'block', color: theme.colors.textMuted, marginBottom: '0.3rem', fontSize: '0.85rem',
};

export const sectionStyle = {
  backgroundColor: theme.colors.background, border: `1px solid ${theme.colors.border}`,
  borderRadius: '10px', padding: '1.2rem 1.5rem', marginBottom: '1rem',
};

// Límites de caracteres que impone Meta a cada campo de una plantilla. Se aplican
// como maxLength en los inputs para que el usuario no pueda escribir/pegar de más.
export const META_LIMITS = {
  headerText: 60,
  body: 1024,        // cuerpo estándar y mensaje principal del carrusel
  footer: 60,
  buttonText: 25,
  url: 2000,
  phone: 20,
  quickReplyPayload: 128,
  cardBody: 160,     // cuerpo de cada tarjeta del carrusel
};
